(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "../../store";
import * as actions from "./state/actions";

const useSubscribeHistory = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    var _location$state;

    dispatch(actions.push(location));

    switch (location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.action) {
      case "PUSH":
        dispatch(actions.push(location));
        break;

      case "REPLACE":
        dispatch(actions.replace(location));
        break;

      default:
        dispatch(actions.pop());
        break;
    } // eslint-disable-next-line

  }, []);
};

__signature__(useSubscribeHistory, "useDispatch{dispatch}\nuseLocation{location}\nuseEffect{}", () => [useDispatch, useLocation]);

const _default = useSubscribeHistory;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useSubscribeHistory, "useSubscribeHistory", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/useSubscribeHistory.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/useSubscribeHistory.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();